import {
  ListItem as MuiListItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core'
import PinDropOutlinedIcon from '@material-ui/icons/PinDropOutlined'
import clsx from 'clsx'

import { useStyles } from './styles'

interface RegionItemProps {
  label: string
  selected?: boolean
  ready?: boolean
  onClick?: React.MouseEventHandler<HTMLDivElement>
}

export function RegionItem({
  label,
  selected,
  ready,
  onClick,
}: RegionItemProps) {
  const classes = useStyles()
  return (
    <MuiListItem
      className={clsx(classes.listItem, { [classes.dotGreen]: ready })}
      button
      selected={selected}
      onClick={onClick}
    >
      <ListItemIcon>
        <PinDropOutlinedIcon />
      </ListItemIcon>
      <ListItemText
        primary={label}
        primaryTypographyProps={{ variant: 'body2' }}
      />
    </MuiListItem>
  )
}
